import { PluginExperimentContext } from "../../pluginsInfrastructure/PluginRegistryTypes";

export const RevisedDesignFirstFlowContext: PluginExperimentContext = {
  experimentKey: "revised_design_first_flow",
  renderTestExperienceForVariations: ["control", "test"],
  fireImpressionForVariations: ["test", "control"],
  supportedMpvIds: ["weddingInvitations", "noteCards", "saveTheDateCards", "thankYouCards"],
  supportedLocales: ["en-US", "en-CA", "es-US", "fr-CA"],
};

export const PDP_MOBILE_PROMO_BAR_EXPERIMENT_TEST_VARIATION = "test";
export const PDP_MOBILE_PROMO_BAR_EXPERIMENT_CONTEXT: PluginExperimentContext = {
  experimentKey: "core_pdp_mobile_promo_bar",
  renderTestExperienceForVariations: ["control", PDP_MOBILE_PROMO_BAR_EXPERIMENT_TEST_VARIATION],
  fireImpressionForVariations: ["control", PDP_MOBILE_PROMO_BAR_EXPERIMENT_TEST_VARIATION],
};
